import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyUnit } from '../../services/unit-toggle.service';

@Pipe({
  name: 'currencyUnit'
})
export class CurrencyUnitPipe implements PipeTransform {

  transform(value: number, unit: CurrencyUnit): string {
    if (value == null) return '';

    let converted = value;
    let suffix = '';

    switch (unit) {
      case 'Crore':
        converted = value / 10000000;
        suffix = ' Cr';
        break;
      case 'Rupees':
      default:
        converted = value;
        suffix = ' ₹';
        break;
    }

    if(suffix == ' Cr'){
      return `${converted.toFixed(2)}${suffix}`;
    }else{
      return `${suffix}${converted.toFixed(2)}`;
    }

    // return `${converted.toFixed(2)}${suffix}`;
  }

}
